import { createSlice } from '@reduxjs/toolkit';

import { ILayoutsCatalogState } from '../../types/layouts/layoutsCatalog';
import { ISeo } from '../../types/layouts/seo';
import { changePage } from '../../thunks';

const initialState: ILayoutsCatalogState = {
  seo: {} as ISeo,
  layoutsIds: [],
  layoutsById: {},
};

const layoutsCatalog = createSlice({
  initialState,
  name: 'layoutsCatalog',
  reducers: {},
  extraReducers: builder => {
    builder.addCase(changePage.fulfilled, (state, action) => {
      state.layoutsIds = action.payload.layoutsCatalog.layoutsIds;
      state.layoutsById = action.payload.layoutsCatalog.layoutsById;
      state.pagination = action.payload.layoutsCatalog.pagination;
    });
  },
});

export const { reducer: layoutsCatalogReducer } = layoutsCatalog;
